<template>
  <div>
    <b-modal
      id="gpiSubstitutionPopup"
      no-close-on-backdrop
      centered
      ref="gpi-substitution-popup-modal"
      class="modal-body">

    <template #modal-header="{ }">
      RECOMMENDATION FOR {{sourceDesc}}
    </template>

      <template #default="{ }">
        <b-row class="gpiSubstitutionPopup-blurb">
          <b-col class="col-11 d-flex mb-2">
            Your facility has opted into utilizing clinical formulary management that will aid in the most appropriate selection of drug therapy based upon best practices, patient-specific factors, and highest cost-avoidance. Please refer to your clinical training module as a more detailed explanation is provided as well as rationale for why certain recommendations will display. You may bypass these recommendations however the non-formulary order will be subjected to non-formulary review.
          </b-col>
        </b-row>
        <b-row v-for="(s, i) in subs" :key="i">
          <b-col class="col-1 my-1 pr-0 d-flex">
            <div class="my-auto"><b-checkbox v-model="selectedSub" :value="s" /></div>
          </b-col>
          <b-col class="col-auto my-1 pl-0 d-flex"><div class="my-auto">{{ s.TargetDesc }}</div></b-col>
          <b-col class="col-10 my-1 d-flex"><div class="my-auto">{{ s.SupportingDoc }}</div></b-col>
        </b-row>
      </template>

      <template #modal-footer="{ }">
          <div class="modal-footer m-f">
              <b-button v-if="isCancelView" class="ml-auto" size="sm" variant="success" @click="reSearchBtn_Click()">
                  CANCEL
              </b-button>
              <b-button size="sm" variant="danger" @click="cancelBtn_Click()">
                  BYPASS
              </b-button>
              <b-button v-if="isButtonView" class="ml-auto" size="sm" variant="success" @click="okBtn_Click()">
                  ACCEPT
              </b-button>
          </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "gpi-substitution-popup",
  props: {},
  data: function () {
    return {
      subs: [],
      selectedSub: null,
      sourceGPI: null,
      sourceDrugID: null,
      facilityID: null,
      callback: null,
      ids: []
    };
  },
  computed:{
    sourceDesc: function(){
      var vm = this;
      if (!vm.subs || vm.subs.length == 0)
        return '';
      return vm.subs[0].SourceDesc;
      },
    isButtonView: function () {
        var vm = this;
        if (!vm.subs || vm.subs.length == 0)
            return false;
        if (vm.subs[0].TargetDrugID == '0')
            return false;

        return true;
      },
    isCancelView: function () {
          var vm = this;
          if (!vm.subs || vm.subs.length == 0)
              return true;
          if (vm.subs[0].TargetDrugID == '0')
              return true;

          return false;
      }
  },
  watch: {},
  methods: {
    init: function () {
      var vm = this;
      vm.getGPISubstitutionPopupVM();
      vm.ids = [];
    },
    showPopupIfNeeded: function (sourceDrugID, callback) {
      var vm = this;
      vm.callback = callback;
      vm.sourceDrugID = sourceDrugID;
      vm.init();
    },
    hidePopup: function () {
      var vm = this;
      vm.$refs["gpi-substitution-popup-modal"].hide();
    },
    cancelBtn_Click: async function () {
      var vm = this;
        await vm.logBypasses();
        if (vm.selectedSub) {
            document.getElementsByClassName('FACGPISubstitutionAuditLogIDs')[0].value = vm.ids.join();
            vm.callback(vm.sourceDrugID, vm.sourceDesc);
            vm.hidePopup();
        }
        else {
            vm.$swal({
                title: "Warning",
                text: "Please acknowledge your desire to bypass the warning.",
                icon: "warning"
            });
        }
    },
    logBypasses: async function() {
      var vm = this;
      for (const x of vm.subs){
        if(!vm.selectedSub || x.ID != vm.selectedSub.ID)
          await vm.setFACGPISubstitutionAuditLog(false, x.ID);
      }
    },
    okBtn_Click: async function () {
      var vm = this;
      if (vm.subs != null && vm.subs.length ==1 )
        vm.selectedSub = vm.subs[0];
      if (vm.selectedSub) {
        await vm.setFACGPISubstitutionAuditLog(true, vm.selectedSub.ID);
        await vm.logBypasses();
        document.getElementsByClassName('FACGPISubstitutionAuditLogIDs')[0].value = vm.ids.join();
        vm.callback(vm.selectedSub.TargetDrugID, vm.selectedSub.TargetDesc);
        vm.hidePopup();
      } else {
        vm.$swal({
          title: "Warning", 
          text: "Please choose a recommendation to accept.", 
          icon: "warning"});
      }
    },
    reSearchBtn_Click: async function () {
        window.location.reload();
    },
    getGPISubstitutionPopupVM: function () {
      var vm = this;
      axios
        .post(
          "../../Common/Services/EmarClientOperations.svc/GetGPISubstitutionPopupVM",
          {
            facilityID: vm.facilityID,
            sourceDrugID: vm.sourceDrugID,
          }
        )
        .then((response) => {
            var d = JSON.parse(response.data.d);
            if (d && d.Substitutions) {
                vm.subs = d.Substitutions;
                if (vm.subs && vm.subs.length > 0)
                    vm.$refs["gpi-substitution-popup-modal"].show();
                else
                    vm.callback(vm.sourceDrugID, vm.sourceDesc);
            }
            else {
                vm.callback(vm.sourceDrugID, vm.sourceDesc);
            }
        })
        .catch(function () {
            vm.callback(vm.sourceDrugID, vm.sourceDesc);
        });
    },
    setFACGPISubstitutionAuditLog: async function(accepted, facGPISubsitutionID){
      var vm = this;
      var response = await axios.post(
          "../../Common/Services/EmarClientOperations.svc/SetFACGPISubstitutionAuditLog",
          {
            subAccepted: accepted,
            facGPISubsitutionID: facGPISubsitutionID
          }
        );
      vm.ids.push(JSON.parse(response.data.d));
    }
  },
};
</script>

<style>
#gpiSubstitutionPopup___BV_modal_body_{
  padding-top: .5rem !important;
}
.m-f{
  justify-content:initial;
}
.gpiSubstitutionPopup-blurb{
  background-color: #333;
  color: LemonChiffon;
  border-bottom: 1px solid #dee2e6;
  font-style: italic;
  font-size: 10px;
}
</style>